import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { NavBar, isFolder } from './nav-bar'
import styles from './nav-bar-item.scss'

export class NavBarItem extends React.Component {

    static propTypes = {
        item: PropTypes.object.isRequired,
        selected: PropTypes.bool.isRequired,
        expanded: PropTypes.bool.isRequired,
        level: PropTypes.number,
        childNavBarProps: PropTypes.object,
        onItemSelect: PropTypes.func,
        onItemExpand: PropTypes.func
    }

    static defaultProps = {
        level: 0,
    }

    render() {
        const { item, level, selected, expanded, onItemSelect, onItemExpand, childNavBarProps } = this.props
        const { icon, label, children, hidden = false, selectable = true, onClick } = item

        if (hidden) return null

        const folder = isFolder(item)

        const padding = level * 32 + 32

        let iconComponent = null

        if (icon) {
            iconComponent = React.cloneElement(icon, {
                className: classNames(styles.icon, {
                    [styles.icon_selected]: selected
                })
            })
        }

        const childNavBar = (expanded && folder) &&
            <NavBar
                id={`${item.id}NavBar`}
                items={children}
                level={level + 1}
                selectedItem={childNavBarProps ? childNavBarProps.selectedItem : null}
                expandedItems={childNavBarProps ? childNavBarProps.expandedItems : []}
                onItemSelect={onItemSelect}
                onItemExpand={onItemExpand}
            />

        return (
            <div id={item.id}>
                <div
                    className={styles.header}
                    style={{ paddingLeft: padding }}
                    onClick={() => {
                        if (onClick) {
                            onClick(item)
                        }
                        if (selectable && !folder) {
                            onItemSelect(item)
                        }
                        if (folder) {
                            onItemExpand(item)
                        }
                    }}
                >
                    {iconComponent}
                    <span
                        className={classNames(styles.label, {
                            [styles.label_selected]: selected,
                            [styles.label_folder]: folder
                        })}
                    >
                        {label}
                    </span>
                </div>
                {childNavBar || null}
            </div>
        )
    }
}
